<template>
    <CCol col="12">
        <ValidationObserver tag="div" ref="form" v-slot="{ handleSubmit, invalid }">
            <CCard>
                <CCardBody>
                    <CForm method="post" @submit.prevent="handleSubmit(submit)">
                        <CRow>
                            <CCustomSelect
                                v-if="localSettings.email_type !== undefined"
                                col="12"
                                v-model="localSettings.email_type"
                                :options="campaignPlanEmailTypeOption"
                                vid="email_type"
                                required
                                rules="required"
                                :name="$t('campaign.settings.email_type')"
                                :description="emailTypeStrDescription(localSettings.email_type)"
                            />

                            <CCustomSelect
                                v-if="localSettings.instagram_ad_type !== undefined"
                                col="12"
                                v-model="localSettings.instagram_ad_type"
                                :options="campaignPlanInstagramAdTypeOption"
                                vid="instagram_ad_type"
                                required
                                rules="required"
                                :name="$t('campaign.settings.instagram_ad_type')"
                                :description="emailTypeStrDescription(localSettings.instagram_ad_type)"
                            />

                            <CCustomInput
                                v-if="localSettings.period !== undefined"
                                col="12"
                                vid="period"
                                :name="$t('campaign.settings.period')"
                                :label="$t('campaign.settings.period') + '('+ $t(`campaign.settings.period_units.${localSettings.period_unit}`) +')'"
                                rules="required|numeric|min_value:1|max_value:6"
                                required
                                ltr
                                type="number"
                                v-model="localSettings.period"
                            />

                            <CCustomInput
                                v-if="localSettings.max_send !== undefined && ![CampaignGoal.ACTIVE_OLD_PUBLISHERS, CampaignGoal.NOTIFICATION].includes(goal)"
                                col="12"
                                vid="max_send"
                                :name="$t('campaign.settings.max_send')"
                                rules="required|numeric|max_value:2000"
                                required
                                ltr
                                type="number"
                                v-model="localSettings.max_send"
                            />

                            <CCustomInput
                                v-if="localSettings.target_clicks !== undefined"
                                col="12"
                                vid="target_clicks"
                                :name="$t('campaign.settings.target_clicks')"
                                rules="required|numeric|max_value:4000"
                                required
                                ltr
                                type="number"
                                v-model="localSettings.target_clicks"
                            />

                            <CCustomInput
                                v-if="localSettings.budget !== undefined"
                                col="12"
                                vid="budget"
                                :name="$t('campaign.settings.budget')"
                                rules="required"
                                required
                                ltr
                                type="number"
                                v-model="localSettings.budget"
                            />

                            <CCol col="12" v-if="localSettings.native_ads !== undefined">
                                <span>{{ $t('campaign.settings.native_ads._') }}</span>
                                <CRow class="mt-2">
                                    <CCol col="12">
                                        <CButton color="facebook" class="p-1 px-2" @click="nativeAdModal = {show: true, item: {title: '', image: ''}}"><FaIcon icon="plus" class="align-middle" /></CButton>
                                    </CCol>

                                    <CCol col="12" class="mt-3" v-if="localSettings.native_ads.length > 0">
                                        <CRow>
                                            <CCol col="3" v-for="(nativeAd, index) in localSettings.native_ads" :key="index">
                                                <CCard>
                                                    <CCardHeader class="mx-auto b-a-0 pb-0">{{ nativeAd.title }}</CCardHeader>
                                                    <CCardBody class="mx-auto">
                                                        <img :src="nativeAd.image" width="100" />
                                                    </CCardBody>
                                                </CCard>
                                            </CCol>
                                        </CRow>
                                    </CCol>
                                </CRow>
                            </CCol>

                            <CCol col="12" v-if="localSettings.content !== undefined && planKey !== CampaignPlan.SMS">
                                <span>{{ planKey === CampaignPlan.REPORTAGE ? $t('campaign.settings.reportage_content') : $t('campaign.settings.content') }}<span class="text-danger">*</span></span>
                                <ckeditor
                                    :editor="editor"
                                    v-model="localSettings.content"
                                    :config="editorConfig"
                                ></ckeditor>
                            </CCol>

                            <CCustomTextarea
                                v-if="localSettings.content !== undefined && planKey === CampaignPlan.SMS"
                                sm="12"
                                :name="$t('campaign.settings.content')"
                                vid="content"
                                rules="required"
                                required
                                v-model="localSettings.content"
                            />

                            <CCol col="12" style="min-height: 200px;" v-if="localSettings.tags !== undefined && $policy('campaign').create_any_or_group">
                                <VueTagsInput
                                    add-only-from-autocomplete
                                    :autocomplete-items="filteredStoreTagsInput"
                                    placeholder="تگ‌های هدف"
                                    autocomplete-always-open
                                    v-model="tag"
                                    :tags="localSettings.tags.map(tag => {return {text: tag.name || tag.text}})"
                                    @tags-changed="newTags => localSettings.tags = newTags"
                                    class="campaign-tg-inp"
                                />
                                <span class="text-muted font-xs mt-1 d-block">ظرفیت ارسال {{ countUsersOfTags }}</span>
                            </CCol>

                            <CCol col="12" class="text-left mt-3">
                                <CButton type="submit" color="primary" :disabled="invalid || (localSettings.content !== undefined && localSettings.content.length === 0)">{{ $t('btn.next_step') }}</CButton>
                            </CCol>
                        </CRow>
                    </CForm>
                </CCardBody>
            </CCard>
        </ValidationObserver>

        <CModal v-if="localSettings.native_ads && nativeAdModal.show" :show.sync="nativeAdModal.show" size="sm">
            <template #header-wrapper>
                <span></span>
            </template>
            <ValidationObserver tag="div" ref="form" v-slot="{ invalid }">
                <CCustomInput
                    col="12"
                    vid="title"
                    :name="$t('campaign.settings.native_ads.title')"
                    rules="required"
                    required
                    v-model="nativeAdModal.item.title"
                />

                <CCustomImageInputFile
                    col="12"
                    vid="image"
                    :name="$t('campaign.settings.native_ads.image')"
                    v-model="nativeAdModal.item.image"
                    path="campaigns"
                    required
                    :rules="{ required: true, ext: ['jpeg','jpg','gif','png'], image_ratio: '1.5' }"
                >
                    <template #after-box>
                        <span class="text-center font-xs d-block text-muted">
                            نسبت عرض به ارتفاع: 3 به 2
                        </span>
                    </template>
                </CCustomImageInputFile>

                <CCol col="12" class="mt-3">
                    <CButton type="submit" color="primary" class="btn-block" :disabled="invalid || !nativeAdModal.item.image" @click="addNativeAds">{{ $t('btn.sabt') }}</CButton>
                </CCol>
            </ValidationObserver>

            <template #footer-wrapper>
                <span></span>
            </template>
        </CModal>
    </CCol>
</template>


<script>
import { mapGetters } from 'vuex'
import { CampaignPlan, CampaignGoal } from '@/constants'
import { campaignPlanEmailTypeOption, campaignPlanInstagramAdTypeOption } from '@/common/data'
import CKEditor from '@ckeditor/ckeditor5-vue2';
import Editor from '@affili/ckeditor5-custom-build/build/ckeditor';
import UploadAdapter from '@/components/UploadAdapter';
import { planStr, emailTypeStrDescription } from './methods'
import VueTagsInput from '@johmun/vue-tags-input'

export default {
    name: 'PlanSettingsForm',

    components: {
        ckeditor: CKEditor.component,
        VueTagsInput,
    },

    props: {
        settings: {
            required: true,
            type: Object,
        },
        planKey: {
            required: true,
        },
        goal: {
            required: true,
        }
    },

    data() {
        return {
            CampaignPlan,
            CampaignGoal,
            campaignPlanEmailTypeOption,
            campaignPlanInstagramAdTypeOption,
            editor: Editor,
            nativeAdModal: {
                show: false,
                item: {}
            },
            localSettings: this.settings,
            tag: '',
        }
    },

    computed: {
        ...mapGetters({
            storeTagsInput: 'store/tagsInput',
            storeTags: 'store/arrayTags'
        }),

        editorConfig() {
            const editorConfig = {
                toolbar: {
                    items: [
                        'heading',
                        'fontSize',
                        '|',
                        'bold',
                        'italic',
                        'link',
                        'bulletedList',
                        'numberedList',
                        '|',
                        'outdent',
                        'indent',
                        '|',
                        'undo',
                        'redo',
                    ]
                },
                link: {
                    decorators: {
                        isExternal: {
                            mode: 'manual',
                            label: 'Open in a new tab',
                            attributes: {
                                target: '_blank',
                            }
                        },
                    }
                },
                extraPlugins: [],
                language: 'fa',
            }

            if ([CampaignPlan.REPORTAGE, CampaignPlan.EMAIL].includes(this.planKey)) {
                editorConfig.toolbar.items.push('imageUpload')
                editorConfig.image = {
                    toolbar: [
                        'imageTextAlternative',
                        'toggleImageCaption',
                        'imageStyle:inline',
                        'imageStyle:block',
                        'imageStyle:side',
                    ],
                }

                editorConfig.extraPlugins.push(this.uploader)
            }

            return editorConfig
        },

        filteredStoreTagsInput() {
            return this.storeTagsInput.filter(i => {
                return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1
            })
        },
        countUsersOfTags() {
            let count = 0
            if (this.localSettings.tags) {
                this.localSettings.tags.forEach(tag => {
                    let sTag = this.storeTags.find(sTag => sTag.name === tag.text)
                    if (sTag) {
                        count = count + sTag.users_count
                    }
                })
            }

            return count
        }
    },

    methods: {
        planStr,
        emailTypeStrDescription,
        uploader(editor) {
            editor.plugins.get( 'FileRepository' ).createUploadAdapter = ( loader ) => {
                return new UploadAdapter( loader );
            };
        },
        submit() {
            if (this.localSettings.max_send !== undefined && [CampaignGoal.ACTIVE_OLD_PUBLISHERS, CampaignGoal.NOTIFICATION].includes(this.goal)) {
                delete this.localSettings.max_send
            }

            this.$emit('submit', this.localSettings)
        },
        addNativeAds() {
            let nativeAds = this.localSettings.native_ads
            nativeAds.push({
                title: this.nativeAdModal.item.title,
                image: this.nativeAdModal.item.image,
            })
            this.$set(this.localSettings, 'native_ads', nativeAds)

            this.nativeAdModal = {show: false, item: {}}
        }
    }
}
</script>

<style lang="scss" scoped>
.campaign-tg-inp::v-deep {
    min-width: 100%;
    .ti-autocomplete {
        position: relative!important;
    }
}
</style>